import { Alert, Box, Loader, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { LicenseForm } from '../components/LicenseForm';
import { useEffect, useState } from 'react';
import { License } from '../api/licenses';
import { useAuth } from '../auth/AuthContext';
import { single } from '../api/licenses';
import { isLeft } from 'fp-ts/lib/Either';

export const EditLicense = () => {
  const { keyId, licenseId } = useParams();
  const auth = useAuth();

  const [license, setLicense] = useState<License | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!auth?.token || !keyId || !licenseId) {
      return;
    }
    single(auth.token, keyId, licenseId).then((result) =>
      isLeft(result) ? setError(result.left.message) : setLicense(result.right)
    );
  }, [auth?.token, keyId, licenseId]);

  if (!keyId || !licenseId) {
    return <Box>Missing keyId or licenseId</Box>;
  }

  return license ? (
    <Box>
      <Title order={3} mb="md">
        Edit License {licenseId}
      </Title>
      <LicenseForm keyId={keyId} license={license} />
    </Box>
  ) : error ? (
    <Alert title="Error" color="red">
      {error}
    </Alert>
  ) : (
    <Loader />
  );
};
